// Themes
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
  RED: "RED",
  DEEP_PURPLE: "DEEP_PURPLE",
  YELLOW: "YELLOW",
  BLACK: "BLACK",
};
